
































import { defineComponent, computed, PropType } from '@vue/composition-api';
import BreadCrumb from '@/data/BreadCrumb';

export default defineComponent({
  name: 'BreadCrumbs',
  props: {
    breadCrumbs:{
      type: Array as PropType<Array<BreadCrumb>>,
      default: []
    }
  },
  emits: {
    click: (id: number) => id > 0
  },
  setup(props) {

    const paths = computed(() => {
      return props.breadCrumbs.slice(0, props.breadCrumbs.length - 1);
    });
    const title = computed((): BreadCrumb | undefined => {
      if(props.breadCrumbs.length === 0) return undefined;
      return props.breadCrumbs[props.breadCrumbs.length - 1];
    });

    return {
      paths,
      title
    }
  }
});
